// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Yo-z","slideIn":"Zo-z"};